import GppBadIcon from '@mui/icons-material/GppBad';
import GppGoodIcon from '@mui/icons-material/GppGood';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import { Box, Chip, Tooltip } from '@mui/material';
import React from 'react';
import { PhoneLookupFields, phonePill, PhonePillTone } from 'utils/phonePill';

const TONES: Record<
  PhonePillTone,
  { color: string; background: string; Icon: typeof GppGoodIcon }
> = {
  green: { color: '#067647', background: '#ECFDF3', Icon: GppGoodIcon },
  yellow: { color: '#8A5300', background: '#FFF4E5', Icon: GppMaybeIcon },
  red: { color: '#B42318', background: '#FEF3F2', Icon: GppBadIcon },
};

/** The labelled pill, for a member's own record. */
export const PhoneStatusPill = ({
  member,
}: {
  member?: PhoneLookupFields | null;
}) => {
  const pill = phonePill(member);
  if (!pill) return null;

  const { color, background, Icon } = TONES[pill.tone];
  return (
    <Chip
      size="small"
      label={pill.label}
      icon={<Icon />}
      sx={{
        backgroundColor: background,
        color,
        fontWeight: 600,
        height: '22px',
        '& .MuiChip-icon': { color, fontSize: '14px', marginLeft: '6px' },
      }}
    />
  );
};

/** Icon only, with the label on hover — for a phone cell in a table. */
export const PhoneStatusBadge = ({
  member,
}: {
  member?: PhoneLookupFields | null;
}) => {
  const pill = phonePill(member);
  if (!pill) return null;

  const { color, Icon } = TONES[pill.tone];
  return (
    <Tooltip title={pill.label} placement="top" arrow>
      <Box
        component="span"
        role="img"
        sx={{ display: 'inline-flex', color, cursor: 'default' }}
      >
        <Icon sx={{ fontSize: '16px' }} />
      </Box>
    </Tooltip>
  );
};
